import { OrderIntentEnum } from '../../enum/forecaster';

export class OrderFromTextResponse {
  intent: OrderIntentEnum;
  items?: ItemDto[];
  text?: string
}

export class ItemDto {
  itemName: string;
  quantity: number;
  modifications?: string;
}